import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { primaryColor } from "assets/jss/material-dashboard-pro-react";
import Button from "components/CustomButtons/Button";
import HTMLEditor from "components/HTMLEditor/HTMLEditor";
import AntDDataGrid from "components/DataGrid/AntDDataGrid";
import styles from "../../ReportStyles.module.css";
import CloseIcon from "@mui/icons-material/Close";

const AcademicSupportUnits = ({ data }) => {
  const [valueContent, setValueContent] = useState(data.description ?? "");

  return (
    <>
      <h3>Institutional Summary: Academic Support Units</h3>

      <p className={styles.reportParagraphTitle}>
        The following is the List of the individuals responsible for each of the
        support units that teach courses required by the program being
        evaluated:
      </p>
      <ul>
        {data?.AcademicSupportUnits?.map((unit, index) => (
          <li
            key={index}
          >{`${unit?.unit}, ${unit?.responsible?.name}, ${unit?.responsible?.title}`}</li>
        ))}
      </ul>
    </>
  );
};

export default AcademicSupportUnits;
